<app-loading *ngIf="contentReady"></app-loading>

<div
  class="bbm-page orders-mobile-page"
  [class.rtl]="isAr"
  [dir]="isAr ? 'rtl' : 'ltr'"
>
  <div class="bbm-shell">

    <!-- HERO -->
    <section class="bbm-hero">

      <div class="bbm-hero-top">

        <div class="bbm-hero-copy">
          <span class="bbm-eyebrow">
            {{ "invoices" | transloco }}
          </span>

          <h2>
            {{ "manage invoices" | transloco }}
          </h2>

          <p>
            {{ stockTotal || allData.length || 0 }}
            {{ "invoices" | transloco }}
          </p>
        </div>

        <div class="bbm-hero-counter">
          <strong>
            {{ stockTotal || allData.length || 0 }}
          </strong>

          <span>
            {{ "invoices" | transloco }}
          </span>
        </div>

      </div>

      <!-- HEADER ACTIONS -->
      <div class="bbm-actions-grid bbm-actions-three bbm-hero-actions noPrint">

        @if (!isDeliveryHero) {
          <button
            type="button"
            class="bbm-action-btn bbm-action-primary"
            (click)="checkWarehouseType()"
          >
            <i class="fa-solid fa-plus"></i>

            <span>
              {{ "add order" | transloco }}
            </span>
          </button>
        }

        @if (isAdmin) {
          <div class="dropdown bbm-dropdown-control">
            <button
              type="button"
              class="bbm-action-btn dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <span>
                <i class="fa-solid fa-store"></i>
                {{ "Pospage" | transloco }}
              </span>
            </button>

            <ul class="dropdown-menu dropdown-menu-end">
              <li *ngFor="let el of allWareHouses">
                <button
                  type="button"
                  class="dropdown-item"
                  (click)="applyWareHouse(el.id)"
                >
                  <i class="fa-solid fa-store"></i>
                  <span>{{ el.name }}</span>
                </button>
              </li>
            </ul>
          </div>
        }

        @if (!showoptions) {
          <button
            *ngIf="isAdmin"
            type="button"
            class="bbm-action-btn"
            (click)="advancedSearch()"
          >
            <i class="fa-solid fa-sliders"></i>

            <span>
              {{ "advanced" | transloco }}
            </span>
          </button>
        } @else {
          <button
            *ngIf="isAdmin"
            type="button"
            class="bbm-action-btn"
            (click)="clearFilters()"
          >
            <i class="fa-solid fa-magnifying-glass"></i>

            <span>
              {{ "normal" | transloco }}
            </span>
          </button>
        }

        @if (selectedDeliveryOrders.length !== 0) {
          <button
            routerLink="/deliveryorders"
            type="button"
            class="bbm-action-btn bbm-action-warning"
          >
            <i class="fa-solid fa-truck-fast"></i>

            <span>
              {{ "ready for delivery" | transloco }}
            </span>

            <b class="bbm-action-count">
              {{ selectedDeliveryOrders.length }}
            </b>
          </button>
        }

        @if ((isAdmin || isSubAdmin) && isCompany) {
          <button
            type="button"
            class="bbm-action-btn"
            (click)="getTodyasOrders()"
          >
            <i class="fa-solid fa-calendar-day"></i>

            <span>
              {{ "todays orders" | transloco }}
            </span>
          </button>
        }

      </div>

    </section>

    <!-- SEARCH / FILTERS -->
    <section
      class="bbm-form-ticket noPrint"
      [class.bbm-ticket-warning]="showoptions"
    >

      @if (showoptions) {

        <div class="bbm-form-head">
          <div>
            <span class="bbm-eyebrow">
              {{ "advanced" | transloco }}
            </span>

            <h3>
              {{ "advanced" | transloco }}
            </h3>
          </div>

          <button
            type="button"
            class="bbm-action-btn bbm-action-warning bbm-action-compact"
            (click)="clearSearch()"
          >
            <i class="fa-solid fa-filter-circle-xmark"></i>

            <span>
              {{ "clear search" | transloco }}
            </span>
          </button>
        </div>

        <!-- INVOICE SEARCH -->
        <div class="bbm-search-row">
          <input
            type="text"
            class="bbm-control"
            [(ngModel)]="searchOrderId"
            placeholder="{{ 'invoice' | transloco }}"
          >

          <button
            type="button"
            class="bbm-action-btn bbm-action-primary"
            (click)="searchOrderbyId()"
          >
            <i class="fa-solid fa-magnifying-glass"></i>

            <span>
              {{ "Search" | transloco }}
            </span>
          </button>
        </div>

        <!-- STATUS FILTERS -->
        <div class="bbm-chip-row bbm-ticket-section">

          <div class="dropdown bbm-dropdown-control">
            <button
              type="button"
              class="bbm-filter-chip dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i class="fa-solid fa-list-check"></i>
              {{ "statusfilter" | transloco }}
            </button>

            <ul class="dropdown-menu">
              <ng-container
                *ngIf="usesSimpleOrderStatusFilter; else fullStatusFilter"
              >
                <li>
                  <button
                    type="button"
                    class="dropdown-item"
                    (click)="applyStatusFilter(5, 'order_status')"
                  >
                    {{ "shipped" | transloco }}
                  </button>
                </li>

                <li>
                  <button
                    type="button"
                    class="dropdown-item"
                    (click)="applyStatusFilter(3, 'order_status')"
                  >
                    {{ "rejected" | transloco }}
                  </button>
                </li>

                <li>
                  <button
                    type="button"
                    class="dropdown-item"
                    (click)="applyStatusFilter(1, 'order_status')"
                  >
                    {{ "pending" | transloco }}
                  </button>
                </li>
              </ng-container>

              <ng-template #fullStatusFilter>
                <li>
                  <button
                    type="button"
                    class="dropdown-item"
                    (click)="applyStatusFilter(1, 'order_status')"
                  >
                    {{ "pending" | transloco }}
                  </button>
                </li>

                <li>
                  <button
                    type="button"
                    class="dropdown-item"
                    (click)="applyStatusFilter(2, 'order_status')"
                  >
                    {{ "approved" | transloco }}
                  </button>
                </li>

                <li>
                  <button
                    type="button"
                    class="dropdown-item"
                    (click)="applyStatusFilter(3, 'order_status')"
                  >
                    {{ "rejected" | transloco }}
                  </button>
                </li>

                <li>
                  <button
                    type="button"
                    class="dropdown-item"
                    (click)="applyStatusFilter(4, 'order_status')"
                  >
                    {{ "on the way" | transloco }}
                  </button>
                </li>

                <li>
                  <button
                    type="button"
                    class="dropdown-item"
                    (click)="applyStatusFilter(5, 'order_status')"
                  >
                    {{ "shipped" | transloco }}
                  </button>
                </li>

                <li>
                  <button
                    type="button"
                    class="dropdown-item"
                    (click)="applyStatusFilter(6, 'order_status')"
                  >
                    {{ "Deferred" | transloco }}
                  </button>
                </li>

                <li>
                  <button
                    type="button"
                    class="dropdown-item"
                    (click)="applyStatusFilter(7, 'order_status')"
                  >
                    {{ "notcontacttheclient" | transloco }}
                  </button>
                </li>

                <li>
                  <button
                    type="button"
                    class="dropdown-item"
                    (click)="applyStatusFilter(8, 'order_status')"
                  >
                    {{ "delivered" | transloco }}
                  </button>
                </li>
              </ng-template>
            </ul>
          </div>

          <div
            class="dropdown bbm-dropdown-control"
            *ngIf="!usesSimpleOrderStatusFilter"
          >
            <button
              type="button"
              class="bbm-filter-chip dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i class="fa-solid fa-truck"></i>
              {{ "delivery status" | transloco }}
            </button>

            <ul class="dropdown-menu">
              <li>
                <button
                  type="button"
                  class="dropdown-item"
                  (click)="applyStatusFilter(1, 'delivery_status')"
                >
                  {{ "delivery in progress" | transloco }}
                </button>
              </li>

              <li>
                <button
                  type="button"
                  class="dropdown-item"
                  (click)="applyStatusFilter(2, 'delivery_status')"
                >
                  {{ "not delivered" | transloco }}
                </button>
              </li>

              <li>
                <button
                  type="button"
                  class="dropdown-item"
                  (click)="applyStatusFilter(3, 'delivery_status')"
                >
                  {{ "delivered" | transloco }}
                </button>
              </li>
            </ul>
          </div>

        </div>

      } @else {

        <div class="bbm-form-head">
          <div>
            <span class="bbm-eyebrow">
              {{ "invoices" | transloco }}
            </span>

            <h3>
              {{ "Phone Number" | transloco }}
            </h3>
          </div>
        </div>

        <div class="bbm-search-row">

          <div class="bbm-search-control">
            <i class="fa-solid fa-phone"></i>

            <input
              type="text"
              class="bbm-control"
              [(ngModel)]="searchKey"
              placeholder="{{ 'Phone Number' | transloco }}"
            >
          </div>

          @if (!searched) {
            <button
              type="button"
              class="bbm-action-btn bbm-action-primary"
              (click)="search()"
            >
              <i class="fa-solid fa-magnifying-glass"></i>

              <span>
                {{ "Search" | transloco }}
              </span>
            </button>
          } @else {
            <button
              type="button"
              class="bbm-action-btn bbm-action-warning"
              (click)="clearSearch()"
            >
              <i class="fa-solid fa-filter-circle-xmark"></i>

              <span>
                {{ "clear search" | transloco }}
              </span>
            </button>
          }

        </div>
      }

    </section>

    <!-- EMPTY STATE -->
    @if (noData && !contentReady) {
      <div class="bbm-empty-state">
        <app-nodata></app-nodata>
      </div>
    }

    <!-- ORDERS -->
    @if (!noData) {
      <section
        class="bbm-ticket-list"
        id="orderstable"
      >
        <article
          class="bbm-ticket"
          *ngFor="let element of allData; trackBy: trackById"
          [ngClass]="getOrderStatusClass(element)"
          [class.bbm-ticket-success]="
            !element.ispartially_completed &&
            (
              +element.order_status === 2 ||
              +element.order_status === 5 ||
              +element.order_status === 8
            )
          "
          [class.bbm-ticket-danger]="+element.order_status === 3"
          [class.bbm-ticket-warning]="
            element.ispartially_completed ||
            +element.order_status === 1 ||
            +element.order_status === 6 ||
            +element.order_status === 7
          "
        >

          <!-- TOP -->
          <div class="bbm-ticket-top">

            <div class="bbm-main-info">

              <div class="bbm-avatar">
                {{ getInitial(element.client_name) }}
              </div>

              <div class="bbm-copy">
                <span>
                  {{ "client" | transloco }}
                </span>

                <h3>
                  {{ element.client_name || '-' }}
                </h3>

                <p>
                  <i class="fa-solid fa-phone"></i>

                  <span class="bbm-code-value">
                    {{ element.phone_number || '-' }}

                    @if (element.another_phone) {
                      <span>
                        - {{ element.another_phone }}
                      </span>
                    }
                  </span>
                </p>
              </div>

            </div>

            <!-- ACTION DROPDOWN -->
            <div class="dropdown bbm-ticket-menu">
              <button
                type="button"
                class="bbm-menu-btn"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i class="fa-solid fa-ellipsis-vertical"></i>
              </button>

              <ul class="dropdown-menu dropdown-menu-end">

                @if (
                  !isAdmin &&
                  element.order_status == 5 &&
                  element.pyments?.[0]?.complated == 0 &&
                  element.pyments?.[0]?.requested == 0
                ) {
                  <li>
                    <button
                      type="button"
                      class="dropdown-item"
                      (click)="requestYourCommission(element.id)"
                    >
                      <i class="fa-solid fa-coins"></i>
                      {{ "request your commission" | transloco }}
                    </button>
                  </li>
                }

                <li>
                  <button
                    type="button"
                    class="dropdown-item"
                    (click)="details(element.id, element.is_from_client)"
                  >
                    <i class="fa-solid fa-eye"></i>
                    {{ "order details" | transloco }}
                  </button>
                </li>

                @if (showAdminContent) {

                  @if (element.order_status != '5') {

                    <li *ngIf="warehouseTypeService.isCompany()">
                      <button
                        type="button"
                        class="dropdown-item"
                        (click)="addToDeliveryOrders(element)"
                      >
                        <i class="fa-solid fa-truck-fast"></i>
                        {{ "ready for delivery" | transloco }}
                      </button>
                    </li>

                    <li
                      *ngIf="
                        warehouseTypeService.isCompany() &&
                        element.order_status != '2' &&
                        element.order_status != '4'
                      "
                    >
                      <button
                        type="button"
                        class="dropdown-item bbm-dropdown-success"
                        (click)="changeorderstatus(element.id, '2')"
                      >
                        <i class="fa-solid fa-check"></i>
                        {{ "accept" | transloco }}
                      </button>
                    </li>

                    <li *ngIf="!isSubAdmin && element.order_status != '3'">
                      <button
                        type="button"
                        class="dropdown-item bbm-dropdown-danger"
                        (click)="rejectorder(element.id)"
                      >
                        <i class="fa-solid fa-xmark"></i>
                        {{ "reject" | transloco }}
                      </button>
                    </li>

                    <li
                      *ngIf="
                        warehouseTypeService.isCompany() &&
                        element.order_status != '4'
                      "
                    >
                      <button
                        type="button"
                        class="dropdown-item"
                        (click)="changeorderstatus(element.id, '4')"
                      >
                        <i class="fa-solid fa-route"></i>
                        {{ "on the way" | transloco }}
                      </button>
                    </li>

                    <li
                      *ngIf="
                        warehouseTypeService.isCompany() &&
                        element.order_status != '3'
                      "
                    >
                      <button
                        type="button"
                        class="dropdown-item bbm-dropdown-warning"
                        (click)="changeorderstatus(element.id, '6')"
                      >
                        <i class="fa-solid fa-clock"></i>
                        {{ "Deferred" | transloco }}
                      </button>
                    </li>

                    <li
                      *ngIf="
                        warehouseTypeService.isCompany() &&
                        element.order_status != '3'
                      "
                    >
                      <button
                        type="button"
                        class="dropdown-item bbm-dropdown-warning"
                        (click)="changeorderstatus(element.id, '7')"
                      >
                        <i class="fa-solid fa-phone-slash"></i>
                        {{ "notcontacttheclient" | transloco }}
                      </button>
                    </li>

                    <li
                      *ngIf="
                        warehouseTypeService.isCompany() &&
                        element.order_status != '3'
                      "
                    >
                      <button
                        type="button"
                        class="dropdown-item bbm-dropdown-success"
                        (click)="changeorderstatus(element.id, '8')"
                      >
                        <i class="fa-solid fa-circle-check"></i>
                        {{ "delivered" | transloco }}
                      </button>
                    </li>

                    <li
                      *ngIf="
                        warehouseTypeService.isCompany() &&
                        element.order_status == '4'
                      "
                    >
                      <button
                        type="button"
                        class="dropdown-item"
                        (click)="addDeliveryHero(element.id)"
                      >
                        <i class="fa-solid fa-motorcycle"></i>
                        {{ "add delivery Hero" | transloco }}
                      </button>
                    </li>

                    <li
                      *ngIf="
                        isAdmin &&
                        warehouseTypeService.isWarehouse()
                      "
                    >
                      <button
                        type="button"
                        class="dropdown-item"
                        (click)="accStatement(element.phone_number)"
                      >
                        <i class="fa-solid fa-chart-line"></i>
                        {{ "accountStatement" | transloco }}
                      </button>
                    </li>

                    <li *ngIf="element.order_status != '4'">
                      <button
                        type="button"
                        class="dropdown-item"
                        (click)="showDiscount(element.id, element.total)"
                      >
                        <i class="fa-solid fa-percent"></i>
                        {{ "discount" | transloco }}
                      </button>
                    </li>

                    <li *ngIf="!isSubAdmin">
                      <button
                        type="button"
                        class="dropdown-item bbm-dropdown-success"
                        (click)="
                          changeorderstatus(
                            element.id,
                            '5',
                            '',
                            element.total
                          )
                        "
                      >
                        <i class="fa-solid fa-check-double"></i>
                        {{ "complated" | transloco }}
                      </button>
                    </li>

                    <li
                      *ngIf="
                        warehouseTypeService.isCompany() ||
                        warehouseTypeService.isWarehouse()
                      "
                    >
                      <button
                        type="button"
                        class="dropdown-item bbm-dropdown-warning"
                        (click)="showPopUpPartiallyCompleted(element)"
                      >
                        <i class="fa-solid fa-circle-half-stroke"></i>
                        {{ "Partially completed" | transloco }}
                      </button>
                    </li>
                  }

                  <li
                    *ngIf="
                      element.order_status == '5' &&
                      element.remaining > 0 &&
                      (isAdmin || isSubAdmin)
                    "
                  >
                    <button
                      type="button"
                      class="dropdown-item"
                      (click)="
                        addremaining(
                          element.paid,
                          element.remaining,
                          element.id
                        )
                      "
                    >
                      <i class="fa-solid fa-money-bill-transfer"></i>
                      {{ "changeCredit" | transloco }}
                    </button>
                  </li>

                  <li>
                    <button
                      type="button"
                      class="dropdown-item"
                      (click)="quickInvoice(element.id)"
                    >
                      <i class="fa-solid fa-print"></i>
                      {{ "Print" | transloco }}
                    </button>
                  </li>

                  <li *ngIf="warehouseTypeService.isCompany()">
                    <button
                      type="button"
                      class="dropdown-item"
                      (click)="getUserItems(element.user_id)"
                    >
                      <i class="fa-solid fa-user"></i>
                      {{ "user info" | transloco }}
                    </button>
                  </li>

                  <li *ngIf="isAdmin">
                    <hr class="dropdown-divider">
                  </li>

                  <li *ngIf="isAdmin">
                    <button
                      type="button"
                      class="dropdown-item bbm-dropdown-danger"
                      (click)="
                        deleteOrder(
                          element.id,
                          element.order_status
                        )
                      "
                    >
                      <i class="fa-solid fa-trash"></i>
                      {{ "Delete" | transloco }}
                    </button>
                  </li>
                }

                @if (isDeliveryHero) {

                  @if (+element.delivery_status === 0) {
                    <li>
                      <button
                        type="button"
                        class="dropdown-item"
                        (click)="
                          changeDeliveryStatus(
                            element.id,
                            1,
                            element.warehouse_id
                          )
                        "
                      >
                        <i class="fa-solid fa-play"></i>
                        {{ "start" | transloco }}
                      </button>
                    </li>
                  }

                  @if (+element.delivery_status === 1) {
                    <li>
                      <button
                        type="button"
                        class="dropdown-item bbm-dropdown-danger"
                        (click)="
                          changeDeliveryStatus(
                            element.id,
                            2,
                            element.warehouse_id
                          )
                        "
                      >
                        <i class="fa-solid fa-xmark"></i>
                        {{ "not delivered" | transloco }}
                      </button>
                    </li>

                    <li>
                      <button
                        type="button"
                        class="dropdown-item bbm-dropdown-success"
                        (click)="
                          changeDeliveryStatus(
                            element.id,
                            3,
                            element.warehouse_id,
                            element.total
                          )
                        "
                      >
                        <i class="fa-solid fa-check"></i>
                        {{ "delivered" | transloco }}
                      </button>
                    </li>
                  }
                }

              </ul>
            </div>

          </div>

          <!-- ORDER STATUS -->
          <div class="bbm-badges-row">

            <span
              class="bbm-status-pill"
              [ngClass]="getOrderStatusClass(element)"
              [class.bbm-status-success]="
                !element.ispartially_completed &&
                (
                  +element.order_status === 2 ||
                  +element.order_status === 5 ||
                  +element.order_status === 8
                )
              "
              [class.bbm-status-danger]="+element.order_status === 3"
              [class.bbm-status-warning]="
                element.ispartially_completed ||
                +element.order_status === 1 ||
                +element.order_status === 6 ||
                +element.order_status === 7
              "
              [class.bbm-status-primary]="+element.order_status === 4"
            >
              @if (element.ispartially_completed) {
                <span>
                  {{ "Partially completed" | transloco }}
                </span>
              } @else {
                <ng-container [ngSwitch]="+element.order_status">
                  <span *ngSwitchCase="1">
                    {{ "pending" | transloco }}
                  </span>

                  <span *ngSwitchCase="2">
                    {{ "approved" | transloco }}
                  </span>

                  <span *ngSwitchCase="3">
                    {{ "rejected" | transloco }}
                  </span>

                  <span *ngSwitchCase="4">
                    {{ "on the way" | transloco }}
                  </span>

                  <span *ngSwitchCase="5">
                    {{ "shipped" | transloco }}
                  </span>

                  <span *ngSwitchCase="6">
                    {{ "Deferred" | transloco }}
                  </span>

                  <span *ngSwitchCase="7">
                    {{ "notcontacttheclient" | transloco }}
                  </span>

                  <span *ngSwitchCase="8">
                    {{ "delivered" | transloco }}
                  </span>
                </ng-container>
              }
            </span>

            @if (element.comment) {
              <span class="bbm-badge bbm-badge-dark">
                <i class="fa-solid fa-comment-dots"></i>
                {{ element.comment }}
              </span>
            }

          </div>

          <!-- REJECTION REASON -->
          @if (+element.order_status === 3 && element.reason) {
            <div class="bbm-alert bbm-alert-danger bbm-ticket-section">
              <i class="fa-solid fa-circle-exclamation"></i>

              <span>
                {{ "rejectedreason" | transloco }}:
                {{ element.reason }}
              </span>
            </div>
          }

          <!-- META -->
          <div class="bbm-details-grid bbm-ticket-section">

            <div class="bbm-detail-chip">
              <i class="fa-regular fa-calendar"></i>

              <span>
                {{ "created at" | transloco }}
              </span>

              <strong>
                {{ element.created_at | date:'dd/MM/yyyy HH:mm' }}
              </strong>
            </div>

            @if (warehouseTypeService.isCompany()) {
              <div class="bbm-detail-chip">
                <i class="fa-regular fa-user"></i>

                <span>
                  {{ "created by" | transloco }}
                </span>

                <strong>
                  {{ element.user_last_name || '-' }}
                </strong>
              </div>

              <div class="bbm-detail-chip bbm-detail-success">
                <i class="fa-solid fa-coins"></i>

                <span>
                  {{ "commission" | transloco }}
                </span>

                <strong>
                  @if (
                    element.duenow &&
                    element.duenow !== 'undefined'
                  ) {
                    {{ element.duenow }}
                    {{ "egp" | transloco }}
                  } @else {
                    {{ "admin" | transloco }}
                  }
                </strong>
              </div>
            }

            @if (element.delivery_hero) {
              <div class="bbm-detail-chip">
                <i class="fa-solid fa-truck-fast"></i>

                <span>
                  {{ "deliveryhero" | transloco }}
                </span>

                <strong>
                  {{ element.delivery_hero }}
                </strong>
              </div>
            }

          </div>

          <!-- DELIVERY STATUS -->
          @if (element.delivery_hero) {
            <div
              class="bbm-alert bbm-ticket-section"
              [ngClass]="getDeliveryStatusClass(element.delivery_status)"
              [class.bbm-alert-warning]="+element.delivery_status === 0"
              [class.bbm-alert-primary]="+element.delivery_status === 1"
              [class.bbm-alert-danger]="+element.delivery_status === 2"
              [class.bbm-alert-success]="+element.delivery_status === 3"
            >
              <i class="fa-solid fa-truck"></i>

              <span>
                {{ "delivery status" | transloco }}:
              </span>

              <strong [ngSwitch]="+element.delivery_status">
                <ng-container *ngSwitchCase="0">
                  {{ "waiting for delivery" | transloco }}
                </ng-container>

                <ng-container *ngSwitchCase="1">
                  {{ "delivery in progress" | transloco }}
                </ng-container>

                <ng-container *ngSwitchCase="2">
                  {{ "not delivered" | transloco }}
                </ng-container>

                <ng-container *ngSwitchCase="3">
                  {{ "delivered" | transloco }}
                </ng-container>
              </strong>
            </div>
          }

          <!-- ADDRESS -->
          <div class="bbm-details-grid bbm-ticket-section">
            <div class="bbm-detail-chip bbm-detail-wide">
              <i class="fa-solid fa-location-dot"></i>

              <span>
                {{ "address" | transloco }}
              </span>

              <div class="bbm-address-value">
                @if (element.grov_id) {
                  <p>
                    {{ element.governorate?.governorate_name_ar }}
                    -
                    {{ element.city?.city_name_ar }}
                  </p>
                }

                <strong>
                  {{ element.address || '-' }}
                </strong>

                @if (
                  element.order_location &&
                  element.order_location !== 'null'
                ) {
                  <a
                    [href]="element.order_location"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i class="fa-solid fa-location-arrow"></i>
                    {{ "map location" | transloco }}
                  </a>
                }
              </div>
            </div>
          </div>

          <!-- PRODUCTS -->
          <div class="bbm-products-block">

            <div class="bbm-block-head">
              <span>
                {{ "order details" | transloco }}
              </span>

              <b>
                #{{ element.id }}
              </b>
            </div>

            <div class="bbm-products-list">
              <div
                class="bbm-product-row"
                *ngFor="
                  let item of tolist(element.item);
                  let i = index
                "
              >
                <span class="bbm-product-name">
                  {{ item }}
                </span>

                <span class="bbm-product-meta">
                  <b>
                    x{{ tolist(element.quantity)[i] || 1 }}
                  </b>

                  <strong>
                    {{ tolist(element.price)[i] || 0 }}
                    {{ "egp" | transloco }}
                  </strong>
                </span>
              </div>
            </div>

          </div>

          <!-- TOTALS -->
          <div class="bbm-totals-block">

            @if (element.discount) {
              <div class="bbm-total-row bbm-total-discount">
                <span>
                  {{ "discount" | transloco }}
                </span>

                <strong>
                  - {{ element.discount }}
                  {{ "egp" | transloco }}
                </strong>
              </div>
            }

            <div class="bbm-total-row">
              <span>
                {{ "delivery" | transloco }}
              </span>

              <strong>
                {{ element.delivery_fees || 0 }}
                {{ "egp" | transloco }}
              </strong>
            </div>

            @if (!isNaN(element.total)) {
              <div class="bbm-total-row bbm-total-grand">
                <span>
                  {{ "total" | transloco }}
                </span>

                <strong>
                  {{ element.total }}
                  {{ "egp" | transloco }}
                </strong>
              </div>
            }

          </div>

          <!-- REMAINING -->
          @if (element.remaining > 0) {
            <div class="bbm-alert bbm-alert-warning bbm-ticket-section">
              <i class="fa-solid fa-triangle-exclamation"></i>

              <span>
                {{ "not_payed" | transloco }}:
                {{ element.remaining }}
                {{ "egp" | transloco }}
              </span>
            </div>
          }

          <!-- PAYMENT TYPE -->
          @if (
            +element.order_status === 5 ||
            element.ispartially_completed
          ) {
            <div class="bbm-details-grid bbm-ticket-section">
              <div class="bbm-detail-chip bbm-detail-wide">
                <i class="fa-solid fa-credit-card"></i>

                <span>
                  {{ "payment_type" | transloco }}
                </span>

                <strong [ngSwitch]="element.payment_type">
                  <ng-container *ngSwitchCase="'0'">
                    {{ "cash" | transloco }}
                  </ng-container>

                  <ng-container *ngSwitchCase="'1'">
                    {{ "vodafone cash" | transloco }}
                  </ng-container>

                  <ng-container *ngSwitchCase="'2'">
                    {{ "instapay" | transloco }}
                  </ng-container>

                  <ng-container *ngSwitchCase="'3'">
                    {{ "online payment" | transloco }}
                  </ng-container>

                  <ng-container *ngSwitchCase="'4'">
                    {{ "bank transfer" | transloco }}
                  </ng-container>

                  <ng-container *ngSwitchCase="'5'">
                    {{ "credit" | transloco }}
                  </ng-container>
                </strong>
              </div>
            </div>
          }

          <!-- QUICK ACTIONS -->
          <div class="bbm-actions-grid bbm-ticket-section">

            <button
              type="button"
              class="bbm-action-btn bbm-action-primary bbm-action-wide"
              (click)="details(element.id, element.is_from_client)"
            >
              <i class="fa-solid fa-eye"></i>

              <span>
                {{ "details" | transloco }}
              </span>
            </button>

            @if (
              isDeliveryHero &&
              +element.delivery_status === 0
            ) {
              <button
                type="button"
                class="bbm-action-btn bbm-action-primary"
                (click)="
                  changeDeliveryStatus(
                    element.id,
                    1,
                    element.warehouse_id
                  )
                "
              >
                <i class="fa-solid fa-play"></i>

                <span>
                  {{ "start" | transloco }}
                </span>
              </button>
            }

            @if (
              isDeliveryHero &&
              +element.delivery_status === 1
            ) {
              <button
                type="button"
                class="bbm-action-btn bbm-action-danger"
                (click)="
                  changeDeliveryStatus(
                    element.id,
                    2,
                    element.warehouse_id
                  )
                "
              >
                <i class="fa-solid fa-xmark"></i>

                <span>
                  {{ "not delivered" | transloco }}
                </span>
              </button>

              <button
                type="button"
                class="bbm-action-btn bbm-action-success"
                (click)="
                  changeDeliveryStatus(
                    element.id,
                    3,
                    element.warehouse_id,
                    element.total
                  )
                "
              >
                <i class="fa-solid fa-check"></i>

                <span>
                  {{ "delivered" | transloco }}
                </span>
              </button>
            }

          </div>

        </article>
      </section>

      <!-- LOAD MORE -->
      @if (hasMore()) {
        <div class="bbm-form-actions noPrint">
          <button
            type="button"
            class="bbm-action-btn bbm-action-primary bbm-action-wide"
            (click)="loadMore()"
            [disabled]="isLoadingMore"
          >
            @if (isLoadingMore) {
              <span class="bbm-loader-spinner"></span>

              <span>
                {{ "loading" | transloco }}
              </span>
            } @else {
              <i class="fa-solid fa-chevron-down"></i>

              <span>
                {{ "see more" | transloco }}
              </span>
            }
          </button>
        </div>
      }
    }

  </div>
</div>

<!-- USER INFO MODAL -->
<div
  *ngIf="showPopUp"
  class="bbm-modal-backdrop noPrint"
  [dir]="isAr ? 'rtl' : 'ltr'"
>
  <section class="bbm-modal-card">

    <div class="bbm-modal-handle"></div>

    <div class="bbm-form-head">
      <div>
        <span class="bbm-eyebrow">
          {{ "user info" | transloco }}
        </span>

        <h3>
          {{ "Name" | transloco }}
        </h3>
      </div>

      <button
        type="button"
        class="bbm-action-btn bbm-action-danger bbm-icon-action"
        (click)="close()"
      >
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>

    <div class="bbm-modal-list">

      <div class="bbm-profile-card">
        <div class="bbm-profile-image">
          <img
            [src]="userimage"
            [alt]="userfirstname || ''"
          >
        </div>

        <h4>
          {{ userfirstname || '-' }}
        </h4>
      </div>

      <div class="bbm-details-grid">

        <div class="bbm-detail-chip">
          <i class="fa-solid fa-user"></i>

          <span>
            {{ "username" | transloco }}
          </span>

          <strong>
            {{ userName || '-' }}
          </strong>
        </div>

        <div class="bbm-detail-chip">
          <i class="fa-solid fa-phone"></i>

          <span>
            {{ "phone" | transloco }}
          </span>

          <strong class="bbm-code-value">
            0{{ userPhone }}
          </strong>
        </div>

      </div>

      <div class="bbm-social-links">

        <a
          class="bbm-action-btn"
          [href]="userInstgram"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i class="fa-brands fa-instagram"></i>
          {{ "instagram" | transloco }}
        </a>

        <a
          class="bbm-action-btn"
          [href]="userFacebook"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i class="fa-brands fa-facebook-f"></i>
          {{ "facebook" | transloco }}
        </a>

        <a
          class="bbm-action-btn"
          [href]="userTiktok"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i class="fa-brands fa-tiktok"></i>
          {{ "tiktok" | transloco }}
        </a>

      </div>

    </div>

    <div class="bbm-form-actions">
      <button
        type="button"
        class="bbm-action-btn bbm-action-danger bbm-action-wide"
        (click)="close()"
      >
        {{ "close" | transloco }}
      </button>
    </div>

  </section>
</div>

<!-- REJECT MODAL -->
<div
  *ngIf="showRejectPopUp"
  class="bbm-modal-backdrop noPrint"
  [dir]="isAr ? 'rtl' : 'ltr'"
>
  <section class="bbm-modal-card">

    <div class="bbm-modal-handle"></div>

    <div class="bbm-form-head">
      <div>
        <span class="bbm-eyebrow">
          {{ "rejectedreason" | transloco }}
        </span>

        <h3>
          {{ "reject" | transloco }}
        </h3>
      </div>

      <button
        type="button"
        class="bbm-action-btn bbm-action-danger bbm-icon-action"
        (click)="close()"
      >
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>

    <div class="bbm-modal-list">
      <div class="bbm-modal-row">
        <label for="rejection">
          {{ "rejectedreason" | transloco }}
        </label>

        <input
          id="rejection"
          class="bbm-control"
          type="text"
          [(ngModel)]="reason"
          placeholder="{{ 'rejectedreason' | transloco }}"
        >
      </div>
    </div>

    <div class="bbm-form-actions">
      <button
        type="button"
        class="bbm-action-btn bbm-action-primary"
        (click)="onSubmit()"
      >
        {{ "Submit" | transloco }}
      </button>

      <button
        type="button"
        class="bbm-action-btn bbm-action-danger"
        (click)="close()"
      >
        {{ "close" | transloco }}
      </button>
    </div>

  </section>
</div>

<!-- COMMENT MODAL -->
<div
  *ngIf="showCommentPopUp"
  class="bbm-modal-backdrop noPrint"
  [dir]="isAr ? 'rtl' : 'ltr'"
>
  <section class="bbm-modal-card">

    <div class="bbm-modal-handle"></div>

    <div class="bbm-form-head">
      <div>
        <span class="bbm-eyebrow">
          {{ "add comment" | transloco }}
        </span>

        <h3>
          {{ "add comment" | transloco }}
        </h3>
      </div>

      <button
        type="button"
        class="bbm-action-btn bbm-action-danger bbm-icon-action"
        (click)="close()"
      >
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>

    <div class="bbm-modal-list">
      <div class="bbm-modal-row">
        <label for="comment">
          {{ "add comment" | transloco }}
        </label>

        <input
          id="comment"
          class="bbm-control"
          type="text"
          [(ngModel)]="comment"
          placeholder="{{ 'comment placeholder' | transloco }}"
        >
      </div>
    </div>

    <div class="bbm-form-actions">
      <button
        type="button"
        class="bbm-action-btn bbm-action-primary"
        (click)="updateComment()"
      >
        {{ "Submit" | transloco }}
      </button>

      <button
        type="button"
        class="bbm-action-btn bbm-action-danger"
        (click)="close()"
      >
        {{ "close" | transloco }}
      </button>
    </div>

  </section>
</div>

<!-- DISCOUNT MODAL -->
<div
  *ngIf="showDiscountPopUp"
  class="bbm-modal-backdrop noPrint"
  [dir]="isAr ? 'rtl' : 'ltr'"
>
  <section class="bbm-modal-card">

    <div class="bbm-modal-handle"></div>

    <div class="bbm-form-head">
      <div>
        <span class="bbm-eyebrow">
          {{ "discount" | transloco }}
        </span>

        <h3>
          {{ "discount" | transloco }}
        </h3>
      </div>

      <button
        type="button"
        class="bbm-action-btn bbm-action-danger bbm-icon-action"
        (click)="close()"
      >
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>

    <div class="bbm-modal-list">
      <div class="bbm-modal-row">
        <label for="discount">
          {{ "discount" | transloco }}
        </label>

        <input
          id="discount"
          class="bbm-control"
          type="number"
          [(ngModel)]="discount"
          placeholder="{{ 'discount value' | transloco }}"
        >
      </div>
    </div>

    <div class="bbm-form-actions">
      <button
        type="button"
        class="bbm-action-btn bbm-action-primary"
        (click)="addDiscount()"
      >
        {{ "Submit" | transloco }}
      </button>

      <button
        type="button"
        class="bbm-action-btn bbm-action-danger"
        (click)="close()"
      >
        {{ "close" | transloco }}
      </button>
    </div>

  </section>
</div>

<!-- DELIVERY HERO MODAL -->
<div
  *ngIf="showDeliveryHeroPopUp"
  class="bbm-modal-backdrop noPrint"
  [dir]="isAr ? 'rtl' : 'ltr'"
>
  <section class="bbm-modal-card">

    <div class="bbm-modal-handle"></div>

    <div class="bbm-form-head">
      <div>
        <span class="bbm-eyebrow">
          {{ "deliveryhero" | transloco }}
        </span>

        <h3>
          {{ "add delivery Hero" | transloco }}
        </h3>
      </div>

      <button
        type="button"
        class="bbm-action-btn bbm-action-danger bbm-icon-action"
        (click)="close()"
      >
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>

    <div class="bbm-modal-list">
      <div class="bbm-modal-row">
        <label for="deliveryHero">
          {{ "add delivery Hero" | transloco }}
        </label>

        <select
          id="deliveryHero"
          class="bbm-control"
          [(ngModel)]="deliveryHero"
          [ngModelOptions]="{ standalone: true }"
          (change)="onDeliveryHeroChange()"
        >
          <option
            [ngValue]="null"
            disabled
          >
            {{ "select" | transloco }}
          </option>

          <option
            *ngFor="let hero of deliveryHeros"
            [ngValue]="hero"
          >
            {{ hero.name }}
          </option>
        </select>
      </div>
    </div>

    <div class="bbm-form-actions">
      <button
        type="button"
        class="bbm-action-btn bbm-action-primary"
        (click)="addHero()"
      >
        {{ "Submit" | transloco }}
      </button>

      <button
        type="button"
        class="bbm-action-btn bbm-action-danger"
        (click)="close()"
      >
        {{ "close" | transloco }}
      </button>
    </div>

  </section>
</div>

<!-- PARTIALLY COMPLETED MODAL -->
<div
  *ngIf="showPartCompPopUp"
  class="bbm-modal-backdrop noPrint"
  [dir]="isAr ? 'rtl' : 'ltr'"
>
  <section class="bbm-modal-card bbm-modal-wide">

    <div class="bbm-modal-handle"></div>

    <div class="bbm-form-head">
      <div>
        <span class="bbm-eyebrow">
          {{ "Partially completed" | transloco }}
        </span>

        <h3>
          {{ "Partially completed" | transloco }}
        </h3>
      </div>

      <button
        type="button"
        class="bbm-action-btn bbm-action-danger bbm-icon-action"
        (click)="close()"
      >
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>

    <div class="bbm-editor-list">

      <div
        class="bbm-editor-row"
        *ngFor="let item of selectedProductsDetails"
      >
        <strong class="bbm-editor-title">
          {{ item.item }}
        </strong>

        <div class="bbm-editor-grid">

          <div class="bbm-field">
            <label>
              {{ "quantity" | transloco }}
            </label>

            <input
              class="bbm-control"
              type="number"
              min="1"
              [max]="item.quantity"
              [(ngModel)]="item.quantity"
              name="quantity_{{ item.product_id }}"
              placeholder="{{ 'quantity' | transloco }}"
            >
          </div>

          <div
            class="bbm-field"
            *ngIf="item.bounes != 0"
          >
            <label>
              {{ "bounes" | transloco }}
            </label>

            <input
              class="bbm-control"
              type="number"
              min="1"
              [max]="item.bounes"
              [(ngModel)]="item.bounes"
              name="bounes_{{ item.product_id }}"
              placeholder="{{ 'bounes' | transloco }}"
            >
          </div>

          <div class="bbm-field">
            <label>
              {{ "price" | transloco }}
            </label>

            <input
              class="bbm-control"
              type="number"
              min="0"
              [disabled]="true"
              [(ngModel)]="item.price"
              name="price_{{ item.product_id }}"
              placeholder="{{ 'price' | transloco }}"
            >
          </div>

        </div>
      </div>

    </div>

    <div class="bbm-form-actions">
      <button
        type="button"
        class="bbm-action-btn bbm-action-primary"
        (click)="partialComplated()"
      >
        {{ "Submit" | transloco }}
      </button>

      <button
        type="button"
        class="bbm-action-btn bbm-action-danger"
        (click)="close()"
      >
        {{ "close" | transloco }}
      </button>
    </div>

  </section>
</div>

<!-- PAYMENT MODAL -->
<div
  *ngIf="showPaymentPopUp"
  class="bbm-modal-backdrop noPrint"
  [dir]="isAr ? 'rtl' : 'ltr'"
>
  <section class="bbm-modal-card">

    <div class="bbm-modal-handle"></div>

    <div class="bbm-form-head">
      <div>
        <span class="bbm-eyebrow">
          {{ "payment_type" | transloco }}
        </span>

        <h3>
          {{ "payment_type" | transloco }}
        </h3>
      </div>

      <button
        type="button"
        class="bbm-action-btn bbm-action-danger bbm-icon-action"
        (click)="close()"
      >
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>

    <div class="bbm-modal-list">

      @if (!changeRemaining) {
        <div class="bbm-modal-row">
          <label>
            {{ "payment_type" | transloco }}
          </label>

          <select
            class="bbm-control"
            [(ngModel)]="payment_type"
          >
            <option value="0">
              {{ "cash" | transloco }}
            </option>

            <option value="1">
              {{ "vodafone cash" | transloco }}
            </option>

            <option value="2">
              {{ "instapay" | transloco }}
            </option>

            <option value="3">
              {{ "online payment" | transloco }}
            </option>

            <option value="4">
              {{ "bank transfer" | transloco }}
            </option>

            <option value="5">
              {{ "credit" | transloco }}
            </option>
          </select>
        </div>
      }

      @if (payment_type == '5' || changeRemaining) {
        <div class="bbm-modal-row">
          <label>
            {{ "payed" | transloco }}
          </label>

          <input
            class="bbm-control"
            type="text"
            placeholder="{{ 'payed' | transloco }}"
            [(ngModel)]="payed"
          >
        </div>

        <div class="bbm-modal-row">
          <label>
            {{ "not_payed" | transloco }}
          </label>

          <input
            class="bbm-control"
            type="text"
            placeholder="{{ 'not_payed' | transloco }}"
            [(ngModel)]="not_payed"
          >
        </div>
      }

    </div>

    <div class="bbm-form-actions">
      <button
        type="button"
        class="bbm-action-btn bbm-action-primary"
        (click)="changePaymentType()"
      >
        {{ "Submit" | transloco }}
      </button>

      <button
        type="button"
        class="bbm-action-btn bbm-action-danger"
        (click)="close()"
      >
        {{ "close" | transloco }}
      </button>
    </div>

  </section>
</div>

<!-- TODAY'S ORDERS MODAL -->
<div
  *ngIf="showtodaysorders"
  class="bbm-modal-backdrop noPrint"
  [dir]="isAr ? 'rtl' : 'ltr'"
>
  <section class="bbm-modal-card">

    <div class="bbm-modal-handle"></div>

    <div class="bbm-form-head">
      <div>
        <span class="bbm-eyebrow">
          {{ "todays orders" | transloco }}
        </span>

        <h3>
          {{ "todays orders" | transloco }}
        </h3>
      </div>

      <button
        type="button"
        class="bbm-action-btn bbm-action-danger bbm-icon-action"
        (click)="close()"
      >
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>

    <div class="bbm-choice-list">

      <button
        type="button"
        class="bbm-choice-btn"
        *ngFor="let item of todaysOrders"
        (click)="getTodaysOrders(item.orders_ids)"
      >
        <span class="bbm-choice-icon">
          <i class="fa-regular fa-calendar-check"></i>
        </span>

        <span class="bbm-choice-copy">
          <strong>
            {{ item.name }}
          </strong>

          <span>
            {{ "todays orders" | transloco }}
          </span>
        </span>
      </button>

    </div>

    <div class="bbm-form-actions">
      <button
        type="button"
        class="bbm-action-btn bbm-action-danger bbm-action-wide"
        (click)="close()"
      >
        {{ "close" | transloco }}
      </button>
    </div>

  </section>
</div>

<!-- QUICK INVOICE MODAL -->
<div
  *ngIf="showQuickInvoice"
  class="bbm-modal-backdrop bbm-modal-printable"
  [dir]="isAr ? 'rtl' : 'ltr'"
>
  <section class="bbm-modal-card bbm-invoice-modal-card">

    <div class="bbm-form-head noPrint">
      <div>
        <span class="bbm-eyebrow">
          {{ "invoice" | transloco }}
        </span>

        <h3>
          #{{ selectedOrderId }}
        </h3>
      </div>

      <button
        type="button"
        class="bbm-action-btn bbm-action-danger bbm-action-compact"
        (click)="close()"
      >
        <i class="fa-solid fa-xmark"></i>
        {{ "close" | transloco }}
      </button>
    </div>

    <div class="bbm-invoice-modal-body">
      <app-invoice [orderid]="selectedOrderId"></app-invoice>
    </div>

  </section>
</div>
